module.exports = __webpack_public_path__ + "static/media/48_A.a62fcede.png";